import React from 'react';
import { ProgressOverlay } from '../../common/progress-overlay/ProgressOverlay';

const Processing = () => {
  return <ProgressOverlay />;
};

export default Processing;
